import Icon from '../components/Icon.vue'

Icon.register({
  heart: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M462.3 62.6c62.8 53.6 66.1 149.8 9.8 207.9l-193.5 199.8c-12.5 12.9-32.8 12.9-45.3 0l-193.5-199.8c-56.2-58.1-52.9-154.3 9.9-207.9 54.8-46.7 136.4-38.3 186.6 13.6l19.7 20.3 19.7-20.3c50.3-51.9 131.8-60.3 186.6-13.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/heart.js
// module id = 1453
// module chunks = 0